@if (focusedVariableDefinitionSg(); as focused) {
  <atn-ds-centered-overlay type="wide">
    <atn-ds-widget
      [title]="isUpdatingSg() ? 'Update Variable' : 'Add Variable'"
    >
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>
      <div class="atn-widget-builder-variable">
        <atn-variable />
      </div>
      <div
        class="atn-widget-builder-variable__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button (click)="saveClickHandler()">{{
          isUpdatingSg() ? 'Update' : 'Add'
        }}</atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
